import type {DetailsPageAppProps} from '../../../components/details-page/Widget/components/app/interfaces'
import type {MemberAppProps} from '../../../components/members-page/interface'
import {getActiveElement} from '../../selectors/focus-handler'
import {connect} from '../runtime-context/connect'
import {FocusHandler as Presentation} from './focus-handler'
import type {FocusHandlerRuntimeProps} from './interfaces'

const mapRuntime = ({
  state,
  actions: {setActiveElement},
}: DetailsPageAppProps | MemberAppProps): FocusHandlerRuntimeProps => ({
  activeElement: getActiveElement(state.focusHandler),
  setActiveElement,
})

export const FocusHandler = connect<any, FocusHandlerRuntimeProps>(mapRuntime)(Presentation)
